import { useTranslation } from "react-i18next";
import { useRecorder } from "../../hooks/useRecorder";
import Modal from "./Modal";

const formatWhen = (timestamp) => {
  const date = new Date(timestamp);
  if (!Number.isFinite(date.getTime())) return "";
  return date.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

function ModalWebRecordingRecovery() {
  const { t } = useTranslation();
  const {
    webRecordingRecovery,
    dismissWebRecordingRecovery,
    reviewWebRecordingRecovery,
    continueAfterWebRecordingReview,
    retryWebRecordingSave,
    recording,
    startingRecording,
  } = useRecorder();

  if (!webRecordingRecovery) return null;

  const { journal, custody, live, retrying } = webRecordingRecovery;
  const liveUnsaved = live === true || custody?.status === "unsaved";
  const checkingFailed = !["complete", "recoverable", "missing"].includes(custody?.status);
  const busy = recording || startingRecording;

  return (
    <Modal
      show
      title={t(`hooks.useRecorder.${liveUnsaved ? "webRecordingSaveTitle" : "webRecordingRecoveryTitle"}`)}
      close={dismissWebRecordingRecovery}
      closeLabel={t("hooks.useRecorder.webRecordingRecoveryClose")}
      action={
        <>
          {liveUnsaved ? (
            <button onClick={retryWebRecordingSave} disabled={busy || retrying || !retryWebRecordingSave}>
              {t(`hooks.useRecorder.${retrying ? "webRecordingSaveRetrying" : "webRecordingSaveRetry"}`)}
            </button>
          ) : (
            <>
              <button onClick={reviewWebRecordingRecovery} disabled={busy}>
                {t("hooks.useRecorder.webRecordingRecoveryReview")}
              </button>
              <button className="white" onClick={continueAfterWebRecordingReview} disabled={busy || checkingFailed}>
                {t("hooks.useRecorder.webRecordingRecoveryContinue")}
              </button>
            </>
          )}
          <button className="white" onClick={dismissWebRecordingRecovery}>
            {t("hooks.useRecorder.webRecordingRecoveryClose")}
          </button>
        </>
      }
    >
      {liveUnsaved ? (
        <p>{t("hooks.useRecorder.webRecordingSaveBody")}</p>
      ) : (
        <>
          <p>{t("hooks.useRecorder.webRecordingRecoveryBody", { when: formatWhen(journal?.startedAt) })}</p>
          {custody?.status === "missing" && <p className="danger">{t("hooks.useRecorder.webRecordingRecoveryMissingAudio")}</p>}
          {checkingFailed && <p className="danger">{t("hooks.useRecorder.webRecordingRecoveryUnknownAudio")}</p>}
          <p>{t("hooks.useRecorder.webRecordingRecoveryBlocked")}</p>
        </>
      )}
    </Modal>
  );
}

export default ModalWebRecordingRecovery;
